import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=21226aa0&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=21226aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21226aa0",
  null
  
)

export default component.exports